import { usePage } from "@inertiajs/react";

import EventForm from "../../../components/events/EventForm";
import Main from "../../../components/layout/Main";
import MetaData from "../../../components/MetaData";
import Heading from "../../../components/theme/Heading";
import { Event } from "../../../types/Event";

const TIME_LENGTH = 16;

const Edit = ({ id, name, published, startsAt }: Event) => {
  const { baseUrl } = usePage().props;
  console.log(published);
  const initialValues = {
    starts_at: startsAt.slice(0, TIME_LENGTH),
    published,
  };

  return (
    <>
      <MetaData title={`${name} bewerken`} />
      <Main>
        <Heading component="h1" marginBottom="1em" variant="h2">
          {`${name} bewerken`}
        </Heading>
        <EventForm
          initialValues={initialValues}
          method="PUT"
          url={`${baseUrl}/events/${id}`}
        />
      </Main>
    </>
  );
};

export default Edit;
